export interface KngBreadcrumb {
  state: KngBreadcrumbState;
}

export interface KngBreadcrumbState {
  breadcrumbData: KngBreadcrumbArr[];
  breadcrumbIcon: { url: string; alt: string };
}

export interface KngBreadcrumbArr {
  id: string;
  label: string;
  url: string;
}
